(function () {

    function sendContactMessage() {
        var $form = $('#contactus-form');
        $.ajax({
            method: "POST",
            url: $form.data('action'),
            data: $form.serialize(),
        }).done(function (data) {
            if (data.success) {
                $form.removeClass('was-validated').find('input, textarea').val('');
                toggleRightNav();
            }
        }).always(function () {
            grecaptcha.reset();
        });
    }

    function refreshCSRF() {
        var $form = $('#contactus-form');
        $.ajax({
            method: "GET",
            url: $form.data('action')
        }).done(function (data) {
            if (data.success) {
                $('[name="csrfmiddlewaretoken"]').val(data.token);
                sendContactMessage();
            }
        });
    }

    window.addEventListener('load', function () {
        var form = document.getElementById('contactus-form');
        form.addEventListener('submit', function (event) {
            event.preventDefault();
            event.stopPropagation();
            const validateRecaptcha = grecaptcha.getResponse();
            if (form.checkValidity() === false || validateRecaptcha.length === 0) {
                form.classList.add('was-validated');
                return;
            }
            refreshCSRF();
        }, false);
    }, false);
})();